import { useApiQuery } from './useApi';
import { configuracionService } from '../services/configuracionService';

/**
 * No todos los clientes usan el módulo de control de combustible — se activa
 * por organización desde Admin > Configuración (/configuracion/organizacion).
 * Este hook lo consulta para decidir si mostrar navegación, rutas y
 * secciones del módulo.
 */
export function useFuelControlEnabled() {
  const { data, isLoading } = useApiQuery(
    ['combustible-configuracion'],
    () => configuracionService.obtener(),
    { staleTime: 5 * 60 * 1000 }
  );

  return {
    habilitado: data?.combustible_habilitado ?? false,
    cargando: isLoading,
  };
}

export default useFuelControlEnabled;
